import * as Yup from 'yup';
export const loginSchema = Yup.object().shape({
    login: Yup.string().required('Nick jest wymagany').min(3, 'Fraza jest za krótka'),
    password: Yup.string().required('Hasło jest wymagane').min(8, 'Hasło jest za krótkie'),
});
